import { toast } from "sonner";
import type { ApiResponse } from "@/types";

type ApiErrorLike = NonNullable<ApiResponse<unknown>["error"]>;

/** Prefer normalized `message` from api-client; fall back to RFC 9457 `detail` or caller fallback. */
export function getApiErrorMessage(
  res: Pick<ApiResponse<unknown>, "error"> | { error?: ApiErrorLike },
  fallback: string,
): string {
  const err = res.error;
  if (!err) return fallback;
  const message = err.message?.trim();
  if (message) return message;
  const detail = typeof err.detail === "string" ? err.detail.trim() : "";
  if (detail) return detail;
  const title = typeof err.title === "string" ? err.title.trim() : "";
  if (title) return title;
  return fallback;
}

export type NotifyApiResultOptions = {
  successMessage?: string;
  errorFallback: string;
  onSuccess?: () => void;
};

/** Show toast for API envelope; returns true when `res.success`. */
export function notifyApiResult<T>(res: ApiResponse<T>, options: NotifyApiResultOptions): boolean {
  if (res.success) {
    if (options.successMessage) toast.success(options.successMessage);
    options.onSuccess?.();
    return true;
  }
  toast.error(getApiErrorMessage(res, options.errorFallback));
  return false;
}
